  "use client";
  import React, { useEffect, useState, useContext, useRef } from "react";
  import { useNavigate } from "react-router-dom";
  import { useParams } from "react-router-dom";
  import api from "../api"; // Use the central API instance
  import { CartContext } from "../cart/CartContext";
  import { QuoteContext } from "../quote/QuoteContext";
  
  const getVariantSize = (variant) => String(variant?.front_size ?? variant?.sizeName ?? "").trim();

  const ProductDetailPage = () => {
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const { id,name } = useParams(); // get product name from URL
    const [product, setProduct] = useState({});
    const [variants, setVariants] = useState([]);
    const hasColor = variants.some(v => Boolean(v.colorName?.trim()));
    const hasSize = variants.some(v => Boolean(getVariantSize(v)));
    const [colors, setColors] = useState([]);
    const [sizes, setSizes] = useState([]);
    const [qty, setQty] = useState(1); // ✅ THIS LINE IS MISSING
    const [selectedColor, setSelectedColor] = useState("");
    const [selectedSize, setSelectedSize] = useState("");
    const [mainImage, setMainImage] = useState("");
    const [stock, setStock] = useState(0);
    const [salePrice, setSalePrice] = useState(0);
    const [customerPrice, setCustomerPrice] = useState(0);
    const [uniqueImages, setUniqueImages] = useState([]);
    const [sizeChartUrl, setSizeChartUrl] = useState("");
    const relatedRef = React.useRef(null);
    const [canScrollLeft, setCanScrollLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(true);
    const [mainVideo, setMainVideo] = useState(null);
    // review
    const [showReviewModal, setShowReviewModal] = useState(false);
    const [reviews, setReviews] = useState([]);
    const [reviewStats, setReviewStats] = useState({});
    const [rating, setRating] = useState(0);
    const [reviewPhotosData, setReviewPhotosData] = useState([]);
    const [reviewForm, setReviewForm] = useState({
        rating: 0,
        text: "",
        title: "",
        name: "",
        email: "",
        agree: false,
    });
    const [reviewImages, setReviewImages] = useState([]);
    useEffect(() => {
    const fetchReviews = async () => {
        try {
          const res = await api.get(`/api/reviews/${id}`);
          setReviews(res.data.reviews);
          setReviewStats(res.data.stats);
          // ✅ extract images from reviews
            const photos = [];
            const reviewList = res.data.reviews || [];
            reviewList.forEach((r) => {
              if (r.images && Array.isArray(r.images)) {
                r.images.forEach((img) => {
                  photos.push({
                    src: img.image_url, // adjust if backend uses different key
                  });
                });
              }
            });

            setReviewPhotosData(photos);
        } catch (err) {
          console.log(err);
        }
      };

      fetchReviews();
    }, [id]);
    const avgRating =
      reviews.length > 0
        ? (reviews.reduce((acc, r) => acc + r.rating, 0) / reviews.length).toFixed(1)
        : 0;
    const Star = ({ filled }) => (
      <svg
        viewBox="0 0 24 24"
        width="18"
        height="18"
        fill={filled ? "var(--wg-orange)" : "none"}
        stroke="var(--wg-orange)"
        strokeWidth="1.4"
      >
        <path d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
      </svg>
    );   
    const ReviewActions = ({ onHelpful, onNotHelpful, onReport }) => {
        return (
          <div className="wg-pdp-review-actions">

            <button
              type="button"
              aria-label="Mark review helpful"
              onClick={onHelpful}
            >
              <svg viewBox="0 0 24 24">
                <path d="M7 12v9H4a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h3Zm4-6-3 8v7h8.28a2 2 0 0 0 1.96-1.61l1.26-6.3a2 2 0 0 0-1.96-2.39H13l1-5a2 2 0 1 0-4 0Z"></path>
              </svg>
              <span>{reviews.helpful_count}Helpful</span>
            </button>

            <button
              type="button"
              aria-label="Mark review not helpful"
              onClick={onNotHelpful}
            >
              <svg viewBox="0 0 24 24">
                <path d="M17 12v9h3a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1h-3Zm-4-6 3 8v7H7.72a2 2 0 0 1-1.96-1.61L4.5 13.09a2 2 0 0 1 1.96-2.39H11l-1-5a2 2 0 1 1 4 0Z"></path>
              </svg>
              <span>{reviews.not_helpful_count}Not helpful</span>
            </button>

            <button
              type="button"
              aria-label="Report review"
              onClick={onReport}
            >
              <svg viewBox="0 0 24 24">
                <path d="M5 21v-9m0 0V3h13l-3 4 3 4H5Z"></path>
              </svg>
              <span>Report</span>
            </button>

          </div>
        );
      };
    const handleHelpful = async (reviewId) => {
      await api.post(`/api/reviews/${reviewId}/helpful`);
    };

    const handleNotHelpful = async (reviewId) => {
      await api.post(`/api/reviews/${reviewId}/not-helpful`);
    };
    const formatDate = (date) =>
    new Date(date).toLocaleDateString("en-US", {
      month: "short",
      day: "2-digit",
      year: "numeric",
    });
     /* my code added */
    // stay in loop
    const [swatches, setSwatches] = useState([]);
    const [submitting, setSubmitting] = useState(false);
    const [newsletter, setNewsletter] = useState({
      name: "",
      email: "",
      phone: "",
      agree: false, 
    });
    const [message, setMessage] = useState("");
    const handleNewsletterChange = (e) => {
      const { name, value, type, checked } = e.target;
    
      setNewsletter((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      }));
    };
    const handleNewsletterSubmit = async () => {
      if (submitting) return;

      // ✅ VALIDATION
      
      if (!newsletter.email && !newsletter.phone) {
        setMessage("Please enter email or phone.");
        return;
      }
    if (!newsletter.agree) {
        setMessage("You must agree to receive marketing messages.");
        return;
      }
    
      setSubmitting(true);
      try { 
        await api.post("/api/newsletter/subscribe", newsletter);
        setNewsletter({
          name: "",
          email: "",
          phone: "",
          agree: false,
        });
     setMessage("Subscribed successfully!"); // ✅ correct place
      } catch (err) {  console.log("ERROR FULL:", err);
        console.log("RESPONSE:", err.response);
        setMessage(err.response?.data?.message || "Something went wrong");
      } finally {
        setSubmitting(false);
      }
    };  
    // for print product desc
    const stripHtml = (html) => {
      const div = document.createElement("div");
      div.innerHTML = html;
      return div.textContent || div.innerText || "";
    };
     // ✅ RELATED
  const [relatedProducts, setRelatedProducts] = useState([]);
    // ✅ RELATED PRODUCTS
    const formatPrice = (value) => {
      if (value === null || value === undefined || isNaN(value)) return "0";
    
      return new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "USD", // change to "INR" if needed
        maximumFractionDigits: 2,
      }).format(value);
    };
    
    useEffect(() => {
      const el = relatedRef.current;
    
      const handleScroll = () => {
        if (!el) return;
    
        setCanScrollLeft(el.scrollLeft > 0);
        setCanScrollRight(
          el.scrollLeft + el.clientWidth < el.scrollWidth
        );
      };
    
      if (el) {
        el.addEventListener("scroll", handleScroll);
        handleScroll(); // run once
      }
    
      return () => el?.removeEventListener("scroll", handleScroll);
    }, [relatedProducts]);

const RelatedSwatches = ({ colors = [], selectedColor, onSelect }) => {
  const [expanded, setExpanded] = React.useState(false);

  if (!colors.length) return null;

  // Check whether selected color is hidden in the first 4
  const selectedIndex = colors.findIndex(
    (c) => c.name === selectedColor?.name
  );

  const selectedIsHidden = selectedIndex >= 4;

  // If user selected a hidden color, keep all colors visible
  const showAll = expanded || selectedIsHidden;

  const visible = showAll ? colors : colors.slice(0, 4);
  const remaining = Math.max(colors.length - 4, 0);

  return (
    <div className="wg-pdp-related-swatches">

      {visible.map((c, i) => (
        <button
          key={c.name || i}
          type="button"
          className={`wg-pdp-related-swatch ${
            selectedColor?.name === c.name ? "is-selected" : ""
          }`}
          title={c.name}
          style={{
            "--swatch-color": c.color_code || "#ccc",
          }}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();

            onSelect(c);

            // If a hidden color was selected,
            // keep all colors visible
            if (i >= 4 || selectedIndex >= 4) {
              setExpanded(true);
            }
          }}
        />
      ))}

      {!showAll && remaining > 0 && (
        <button
          type="button"
          className="wg-plp-swatch-more"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setExpanded(true);
          }}
        >
          +{remaining}
        </button>
      )}

    </div>
  );
};
    
  const [currentMediaList, setCurrentMediaList] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const normalizeMedia = (mediaList) => {
    return mediaList || [];
  };
  const media = uniqueImages
  .filter(img => img.color === selectedColor)
  .map(img => ({
    type: "image",
    src: img.url,
  }));
  useEffect(() => {
    if (!selectedColor || !uniqueImages.length) return;
  
    const filtered = uniqueImages.filter(
      img => img.color === selectedColor
    );
  
    const mediaList = filtered.map(img => ({
      type: "image",
      src: img.url
    }));
  
    setCurrentMediaList(mediaList);
  
    // ✅ set first image as main
    if (mediaList.length > 0) {
      setMainImage(mediaList[0].src);
      setActiveIndex(0);
    }
  
  }, [selectedColor, uniqueImages]);
  // ✅ HERO IMAGE CHANGE
  const setHero = (src, index) => {
    setMainImage(src);
    setActiveIndex(index);
  };

  // ✅ MEDIA OVERLAY
  const [showMediaOverlay, setShowMediaOverlay] = useState(false);
  const [overlayIndex, setOverlayIndex] = useState(0);

  const openMediaOverlay = (index) => {
    setOverlayIndex(index);
    setShowMediaOverlay(true);
  };
  const closeMediaOverlay = () => {
    setShowMediaOverlay(false);
  };
  const thumbsRef = useRef(null);

const scrollThumbs = (direction) => {
  if (!thumbsRef.current) return;

  const scrollAmount = 100; // px per click
  if (direction === 'prev') {
    thumbsRef.current.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
  } else {
    thumbsRef.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
  }
};
// Inside your component
const [images, setImages] = useState([]);

// After fetching the product data:
useEffect(() => {
  if (product?.variants) {
    // Collect all variant images
    const allImages = product.variants
      .map(v => v.frontimage)
      .filter(Boolean); // remove null/undefined
    setImages(allImages);
  }
}, [product]);
 const shipDayOptions = {
      same_or_next_day: "Same or Next Business Day",
      "2_3_days": "2 to 3 Business Days",
      "4_5_days": "4 to 5 Business Days",
      "6_7_days": "6 to 7 Business Days"
    };
/// Accordion
  const [activeAccordion, setActiveAccordion] = useState(["description"]);

  const toggleAccordion = (id) => {
    setActiveAccordion((prev) =>
      prev.includes(id)
        ? prev.filter((i) => i !== id)
        : [...prev, id]
    );
  };

  const accordionData = [
    {
      id: "description",
      title: "Product Description",
      content: product.description,
    },
    {
      id: "bulk",
      title: "Bulk Orders & Custom Imprinting",
      content:
        "Need 24+ units or custom logos? Contact sales for volume pricing and imprinting options. Typical lead times: 7-10 business days after proof approval.",
    },
    {
      id: "shipping",
      title: "Shipping",
      content:
         <>
            <b>
              Average time to ship for this item:
              <br />
              {shipDayOptions[product.ship_day] || ""}
              <br />
            </b>
            Orders from different manufacturers with different shipping times will
            ship in separate packages. We will send tracking info for each package
            as soon as available.
          </>
          },
    {
      id: "returns",
      title: "Returns",
      content:
        "Returns accepted within 30 days in new condition. Start a return online for a prepaid label; exchanges ship once items are received.",
    },
  ];
 /// color box
const Swatches = ({ variants = [], selectedColor, setSelectedColor }) => {
  const [expanded, setExpanded] = useState(false);

  // Build unique colors from variants
  const unique = [];
  const map = new Map();

  variants.forEach((v) => {
    if (v.colorName && v.color_code && !map.has(v.colorName)) {
      map.set(v.colorName, {
        name: v.colorName,
        hex: v.color_code,
      });

      unique.push({
        name: v.colorName,
        hex: v.color_code,
      });
    }
  });

  if (!unique.length) return null;

  const remaining = Math.max(unique.length - 4, 0);

  // Show all when expanded
  // Also show all if selected color is one of the hidden colors
  const selectedIndex = unique.findIndex(
    (s) => s.name === selectedColor
  );

  const selectedIsHidden = selectedIndex >= 4;

  const shouldShowAll = expanded || selectedIsHidden;

  const visible = shouldShowAll
    ? unique
    : unique.slice(0, 4);

  return (
    <div
      className="wg-pdp-swatches"
      id="wgColorSwatches"
      role="group"
    >
      {visible.map((s, i) => (
        <button
          key={s.name}
          type="button"
          className={`wg-pdp-swatch ${
            selectedColor === s.name
              ? "is-selected active"
              : ""
          }`}
          title={s.name}
          style={{
            "--swatch-color": s.hex,
          }}
          onClick={() => {
            setSelectedColor(s.name);

            // Once user selects a hidden color,
            // keep all colors visible
            if (i >= 4 || selectedIndex >= 4) {
              setExpanded(true);
            }
          }}
        />
      ))}

      {!shouldShowAll && remaining > 0 && (
        <button
          type="button"
          className="wg-plp-swatch-more"
          onClick={() => setExpanded(true)}
        >
          +{remaining}
        </button>
      )}
    </div>
  );
};
 

  // ✅ CUSTOMIZATION MODAL
  const [showCustomize, setShowCustomize] = useState(false);

  // ✅ PRESET
  const [selectedPreset, setSelectedPreset] = useState("");
  const [customerPresets, setCustomerPresets] = useState([]);

  // ✅ CUSTOM SELECTIONS
  const [customSelections, setCustomSelections] = useState([]);
  const [customQty, setCustomQty] = useState(1);
  const [customTotal, setCustomTotal] = useState(0);

  // ✅ SIDES & ZONES
  const [customizationSides, setCustomizationSides] = useState([
    { id: "front", label: "Front" },
    { id: "back", label: "Back" }
  ]);


  const [activeSide, setActiveSide] = useState("front");

  const [customizationZones, setCustomizationZones] = useState([]);
  const [activeZone, setActiveZone] = useState(null);

  // ✅ CUSTOMER OPTIONS
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [customerOptions, setCustomerOptions] = useState([]);

  // ✅ TEXT INPUT
  const [customText, setCustomText] = useState("");

  // ✅ STANDARD OPTIONS
  const [selectedStandard, setSelectedStandard] = useState("");
  const [standardOptions, setStandardOptions] = useState([]);
    /*end */
   
    const { addToCart } = useContext(CartContext); // use CartContext
    const { addToQuote } = useContext(QuoteContext);
    useEffect(() => {
      document.title = "Product Details | Workgear365";
    }, []);
    // Fetch related product you may like section
    useEffect(() => {
      const fetchRelatedProducts = async () => {
        try {
          const res = await api.get(`/api/related-products/${id}`);
          console.log("RELATED API:", res.data);
    
          const products =
            res.data?.data?.data || // paginated
            res.data?.data ||       // normal
            [];
    
          setRelatedProducts(Array.isArray(products) ? products : []);
         
        } catch (err) {
          console.error("Error fetching related products:", err);
          setRelatedProducts([]);
        }
      };
    
      fetchRelatedProducts();
    }, [id]);
    const submitReview = async () => {
      try {
        const formData = new FormData();

        formData.append("product_id", id);
        formData.append("rating", reviewForm.rating);
        formData.append("review_body", reviewForm.text);
        formData.append("name", reviewForm.name);
        formData.append("email", reviewForm.email);

        for (let i = 0; i < reviewImages.length; i++) {
          formData.append("images[]", reviewImages[i]);
        }

        await api.post("/api/reviews", formData);

        alert("Review submitted successfully");

        setShowReviewModal(false);

        // refresh reviews
        const res = await api.get(`/api/reviews/${id}`);
        setReviews(res.data.reviews);
        setReviewStats(res.data.stats);

      } catch (err) {
        console.log(err);
      }
    };
    // Fetch product and variants
  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const res = await api.get(`/api/product/${id}`);
        const prod = res.data.data;
        const allVariants = prod.variants || [];

        setProduct({
          ...prod,
          ship_day: prod.vendor?.ship_day || prod.ship_day
        });
        setSwatches(prod.swatches || []);
        setVariants(allVariants);
        //set size chart
        const brand = prod.Brand;
        const productId = prod.id;
        
        // If brand is null or empty, no PDF
       // console.log(prod.show_size_chart);
      if (prod.show_size_chart == 0 && brand && productId) {
          setSizeChartUrl(
            `${api.defaults.baseURL}/api/pdf/sizecharts/brand/${brand}/product/${productId}/pdf`
          );
        } else {
          setSizeChartUrl("");
        }

        // Unique colors
        const uniqueColors = [...new Set(allVariants.map(v => v.colorName))];
        setColors(uniqueColors);
       
        // Default variant
        if (allVariants.length > 0) { 
          const firstVariant =
            allVariants.find((variant) => variant.colorName && getVariantSize(variant)) ||
            allVariants.find((variant) => variant.colorName) ||
            allVariants.find((variant) => getVariantSize(variant)) ||
            allVariants[0];

          setSelectedColor(firstVariant.colorName || "");
          setSelectedSize(getVariantSize(firstVariant));

          setMainImage(firstVariant.frontimage || "");
          setStock(firstVariant.qty || 0);
          setSalePrice(firstVariant.variantPrice || 0);
          setCustomerPrice(firstVariant.customerPrice || 0);
        }
       
        // Prepare unique images grouped by color
        const groupedByColor = allVariants.reduce((acc, variant) => {
          if (!acc[variant.colorName]) acc[variant.colorName] = [];
          acc[variant.colorName].push(variant); 
          return acc;
        }, {});

        const images = [];
        Object.entries(groupedByColor).forEach(([color, variations]) => {
          const seenImages = new Set();
          variations.forEach(v => {
            ["frontimage", "backimage", "sideimage",'model_frontimage','model_backimage','model_sideimage'].forEach(type => {
              const img = v[type];
              if (img && !seenImages.has(img)) {
                seenImages.add(img);
                images.push({ color, type, url: img });
              }
            });
          });
        });

        setUniqueImages(images);
        setCurrentMediaList(
          images.map((img) => ({
            type: "image",
            src: img.url,
          }))
        );
        setLoading(false);
      } catch (err) {
        console.error("Error fetching product:", err);
      }
      
    };

    fetchProduct();
  }, [id]);
 // useEffect(() => {
 //   if (!variants.length || !selectedColor) return;
  
 //   const filtered = variants.filter(
 //     v => v.colorName?.toLowerCase().trim() === selectedColor?.toLowerCase().trim()
 //   );
  
 //   const uniqueSizes = [...new Set(filtered.map(v => v.sizeName))];
  
 //   setSizes(uniqueSizes);
  
    // ALWAYS reset size when color changes
   // setSelectedSize(uniqueSizes[0] || "");
  
  //}, [selectedColor]);
useEffect(() => {
  if (!variants.length || !hasSize || !selectedSize) return;

  const selectedSizeNormalized = selectedSize.toLowerCase().trim();

  const filteredColors = variants.filter(
    v =>
      getVariantSize(v).toLowerCase() === selectedSizeNormalized
  );

  const uniqueColors = [
    ...new Set(filteredColors.map(v => v.colorName).filter(Boolean))
  ];

  setColors(uniqueColors);

  setSelectedColor(prev => {
    const matchedColor = uniqueColors.find(
      color =>
        color.toLowerCase().trim() === prev?.toLowerCase().trim()
    );

    return matchedColor || "";
  });
}, [selectedSize, variants, hasSize]);
useEffect(() => {
  if (!variants.length) return;

  if (!hasSize) {
    setSizes([]);
    return;
  }

  const selectedColorNormalized = selectedColor.toLowerCase().trim();

  const filteredSizes = variants.filter(
    v =>
      !hasColor || !selectedColor || v.colorName?.toLowerCase().trim() === selectedColorNormalized
  );

  const uniqueSizes = [
    ...new Set(filteredSizes.map(getVariantSize).filter(Boolean))
  ];

  setSizes(uniqueSizes);

  // IMPORTANT:
  // selectedSize ને અહીં reset કરવાનું નથી.
}, [selectedColor, variants, hasColor, hasSize]);

    // Update selected variant when color or size changes
    useEffect(() => {
      if (!variants.length) return;
    
      const variant = variants.find(
        v => (!hasColor || v.colorName === selectedColor) && (!hasSize || getVariantSize(v) === selectedSize)
      );
    
      if (variant) {
        setStock(variant.qty || 0);
        setSalePrice(variant.variantPrice || 0);
        setCustomerPrice(variant.customerPrice || 0);
    
        // ✅ only update image if color changed
        if (variant.frontimage) {
          setMainImage(variant.frontimage);
        }
      }
    
    }, [selectedColor, selectedSize, variants, hasColor, hasSize]);
    // ✅ MODAL STATE (ADD THIS) add to cart n quote
        const [showCartModal, setShowCartModal] = useState(false);
        const [showQuoteModal, setShowQuoteModal] = useState(false);

        const [modalData, setModalData] = useState({});
        const handleAddToCart = async () => {
          //console.log("CLICKED");
        
          try {
            const res = await addToCart({
              store_id: product.store_id,
              product_id: product.id,
              styleName: product.styleName,
              selectedColor: hasColor ? selectedColor : "no_color",
              selectedSize: hasSize ? selectedSize : "no_size",
              quantity: qty,
            });
        
           // console.log("SUCCESS");
        
            setModalData({
              name: product.name,
              color: hasColor ? selectedColor : "No color",
              size: hasSize ? selectedSize : "No size",
              qty,
            });
            //alert('SUCCESS');
            setShowCartModal(true);
           // alert('2 SUCCESS');
          } catch (err) {  //alert('FAILED');
            console.log("FAILED", err);
          }
        };

    // Add to quote still uses API directly
    const handleAddToQuote = () => { 
      const finalColor = hasColor ? selectedColor : "no_color";
      const finalSize = hasSize ? selectedSize : "no_size";
    
      setModalData({
        name: product.name,
        color: finalColor,
        size: finalSize,
        qty,
      });
    
      setShowQuoteModal(true); // ✅ only popup open
    };

    const discount = customerPrice > salePrice
      ? Math.round(((customerPrice - salePrice) / customerPrice) * 100)
      : 0;
  /*  if (loading) {
    return (
        <div className="container py-5 text-center">
          <div className="spinner-border text-primary" />
          <p className="mt-2">Loading product...</p>
        </div>
      );
    } */

    
  return (
    <div className="">
         
        <div className="wg-pdp-shell">
    <div className="wg-pdp-card">

      {/* MEDIA */}
      <div className="wg-pdp-media">
        <div className="wg-pdp-hero">
          {mainImage && (
            <img src={mainImage} alt="Product" />
          )}
        </div>

        <div className="wg-pdp-thumb-rail">
  {/* Top Nav */}
  <div className="wg-pdp-thumb-nav top">
    <button type="button" onClick={() => scrollThumbs('prev')}>◀</button>
  </div>

  {/* Viewport */}
  <div className="wg-pdp-thumb-viewport">
    <div className="wg-pdp-thumbs is-compact" ref={thumbsRef}>
   {currentMediaList.map((img, i) => {
      // console.log(img); // see what properties are available
    const isActive = mainImage === img.src;
    const isVideo = img.type === "video";

    return (
      <button
        key={i}
        type="button"
        className={`wg-pdp-thumb ${isActive ? "is-active" : ""} ${isVideo ? "is-video" : ""}`}
        data-index={i}
        data-type={img.type}
        data-src={img.src}
        aria-label={`${isVideo ? "Play video" : "View image"} ${i + 1}`}
        style={{ backgroundImage: `url('${img.src}')` }}
        onClick={() => {
          if (img.type === "video") {
            setMainVideo(img);
          } else {
            setMainImage(img.src);
            setMainVideo(null);
          }
        }}
      />
    );
  })}
    </div>
  </div>

  {/* Bottom Nav */}
  <div className="wg-pdp-thumb-nav bottom">
    <button type="button" onClick={() => scrollThumbs('next')}>▶</button>
  </div>
</div>
      </div>

      {/* META */}
      <div className="wg-pdp-meta">
        <a className="wg-pdp-brand" href="#">
          {product.Brand}
        </a>

        <div className="wg-pdp-title">
          {product.name}
        </div>

        <div className="wg-pdp-item">
          Style: {product.styleName}
        </div>
        <div className="wg-pdp-stars" id="wgStars">
            <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>

              {[1, 2, 3, 4, 5].map((star) => (
                <span key={star}>
                  <Star filled={star <= Math.round(avgRating)} />
                </span>
              ))}

              <span style={{ color: "var(--wg-text-muted)", fontSize: "0.9rem" }}>
                ({reviews.length} reviews)
              </span>

            </span>
          </div>
        {/* PRICE */}
        <div className="wg-pdp-price-row">
          <span className="wg-pdp-price">{formatPrice(salePrice)}</span>

          {customerPrice > salePrice && (
            <span className="wg-pdp-price-list">
             {formatPrice(customerPrice)}
            </span>
          )}

          {discount > 0 && (
            <span className="wg-pdp-badge">
              {discount}% OFF
            </span>
          )}
        </div>

        {/* STOCK */}
        <div className="wg-pdp-stock">
          {stock > 0 ? "In Stock" : "Out of Stock"}
        </div>

     {/* COLOR BOX */}
      {hasColor && (
        <div className="wg-pdp-section" id="wgColorsSection">
          <div className="wg-pdp-label-row">
          <div className="wg-pdp-label">Color</div>
           {selectedColor && (
            <div className="wg-pdp-selected-color">
              {selectedColor}
            </div>
            )}
           </div>
        
         {/*  <button type="button" 
          className="wg-pdp-swatch" 
          data-color="Safety Yellow" 
          style={{ "--swatch-color": "#f6dd3b" }}
          aria-label="Select color Safety Yellow"></button> */}
         { <Swatches 
              variants={product.variants} 
              selectedColor={selectedColor}
              setSelectedColor={setSelectedColor}
            /> }
         
         {/*  <div className="wg-pdp-swatches">
          <Swatches variants={product.variants} />
          </div> */}
        </div>
      )}
        {/* SIZES */}
          {hasSize && (
            <div className="wg-pdp-section">
              <div className="wg-pdp-label-row">
                <div className="wg-pdp-label">Select Size</div>
            
                {sizeChartUrl && (
                  <a
                    href={sizeChartUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="wg-pdp-size-guide"
                    id="wgSizeGuide"

                  >
                    {/* <a href="#" className="wg-pdp-size-guide" id="wgSizeGuide" target="_blank" rel="noopener">
                <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M7 17l10-10M11 7h6v6" strokeLinecap="round" strokeLinejoin="round"/></svg>
                <span>Size guide</span>
              </a> */}
              <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M7 17l10-10M11 7h6v6" strokeLinecap="round" strokeLinejoin="round"/></svg>
                    Size Chart
                  </a>
                )}
            
              </div>

              <div className="wg-pdp-sizes">
                <select
                className="wg-pdp-size-dropdown"
                value={selectedSize}
                onChange={(e) => setSelectedSize(e.target.value)}
                >
                <option value="">Select Size</option>
                {sizes.map((size, i) => (
                <option key={i} value={size}>
                {size}
                </option>
                ))}
                </select>
              </div>
             {/* <button
                type="button"
                className={`wg-pdp-customize ${
                  selectedColor && selectedSize ? "" : "is-disabled"
                }`}
                disabled={!selectedColor || !selectedSize}
                onClick={() => setShowCustomize(true)}
              >
                Choose Options to Customize
              </button> */}
            </div>
          )}
          
        {/* ACTIONS */}
        <div className="wg-pdp-actions">
          <div className="wg-pdp-actions-main">

            {/* QTY */}
            <div className="wg-pdp-qty-col">
            <div className="wg-pdp-qty">
              <button
                type="button"
                className="wg-pdp-qty-btn"
                aria-label="Decrease quantity"
                onClick={() => setQty((prev) => Math.max(1, prev - 1))}
              >
                -
              </button>

              <input
                type="number"
                value={qty}
                min="1"
                aria-label="Quantity"
                onChange={(e) =>
                  setQty(Math.max(1, Number(e.target.value) || 1))
                }
              />

              <button
                type="button"
                className="wg-pdp-qty-btn"
                aria-label="Increase quantity"
                onClick={() => setQty((prev) => prev + 1)}
              >
                +
              </button>
            </div>
          </div>

            {/* ADD TO CART */}
            <button
              type="button"
              className="wg-pdp-btn-cart"
              id="wgAddToCart"
              disabled={(hasColor && !selectedColor) || (hasSize && !selectedSize)}
              onClick={handleAddToCart}
            >
              Add to Cart
            </button>

            {/* ADD TO QUOTE */}
            <button
              type="button"
              className="wg-pdp-btn-quote"
              id="wgAddToQuote"
              onClick={handleAddToQuote}
            >
              Add to Quote
            </button>
          </div>
          <button type="button" className="wg-pdp-btn-secure" aria-label="Secure checkout">
              <svg viewBox="0 0 24 24" fill="none" stroke="var(--wg-orange)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M6 10V7a6 6 0 0 1 12 0v3"/>
                <rect x="5" y="10" width="14" height="10" rx="2" ry="2" fill="none"/>
                <path d="M12 14v2"/>
                <circle cx="12" cy="12.5" r="0.5" fill="var(--wg-orange)" stroke="none"/>
              </svg>
              <span><a href="/cart">Secure checkout</a></span>
            </button>
           {/*  <div className="wg-pdp-share" aria-label="Share product">
              <span className="wg-pdp-share-label">Share:</span>
              <div className="wg-pdp-share-links">
                <a className="wg-pdp-share-btn" id="wgShareFb" href="#" target="_blank" rel="noopener" aria-label="Share on Facebook">
                  <svg viewBox="0 0 24 24" fill="currentColor"><path d="M13 10h2.5l.5-3H13V5.5c0-.9.3-1.5 1.6-1.5H16V1.1C15.1 1 14.1 1 13 1c-2.4 0-4 1.6-4 4.3V7H6v3h3v9h4v-9Z"/></svg>
                </a>
                <a className="wg-pdp-share-btn" id="wgShareIg" href="#" target="_blank" rel="noopener" aria-label="Share on Instagram">
                  <svg viewBox="0 0 24 24" fill="currentColor"><path d="M7 3h10a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4Zm0 2a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H7Zm11 1.5a1 1 0 1 1-2 0a1 1 0 0 1 2 0ZM12 8.5A3.5 3.5 0 1 1 8.5 12A3.5 3.5 0 0 1 12 8.5Zm0 2a1.5 1.5 0 1 0 1.5 1.5A1.5 1.5 0 0 0 12 10.5Z"/></svg>
                </a>
                <a className="wg-pdp-share-btn" id="wgShareX" href="#" target="_blank" rel="noopener" aria-label="Share on X">
                  <svg viewBox="0 0 24 24" fill="currentColor"><path d="M4 4h4.1l3.1 4.5 3.6-4.5H20l-6 7.2L20 20h-4.1l-3.5-5-3.9 5H4l6.2-7.4Z"/></svg>
                </a>
                <a className="wg-pdp-share-btn" id="wgShareEmail" href="#" target="_blank" rel="noopener" aria-label="Share via email">
                  <svg viewBox="0 0 24 24" fill="currentColor"><path d="M3 5h18a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Zm1.2 2 7.3 4.8c.3.2.7.2 1 0L19.8 7H4.2Zm15.6 10V9.1l-6.6 4.4c-.7.5-1.7.5-2.4 0L4.2 9.1V17h15.6Z"/></svg>
                </a>
              </div>
            </div> */}
        </div>
      </div>
          {/* ACCORDION */}
          
          {/* DESCRIPTION */}
          {accordionData.map((item) => {
          const isOpen = activeAccordion.includes(item.id);

          return (
            <div key={item.id} className="wg-pdp-accordion wg-pdp-full">
              <button
                type="button"
                className={`wg-pdp-accordion-toggle ${isOpen ? "active" : ""}`}
                onClick={() => toggleAccordion(item.id)}
              >
                <span>{item.title}</span>
                <span>{isOpen ? "▲" : "▼"}</span>
              </button>

              <div
                className="wg-pdp-accordion-body"
                style={{ display: isOpen ? "block" : "none" }}
              >
                {item.id === "description" ? (
                <div
                  dangerouslySetInnerHTML={{
                    __html: product.description || "No description available",
                  }}
                />
              ) : (
                item.content
              )}
           </div>
            </div>
          );
        })}
    </div>
    </div>
    <div className="wg-pdp-shell">
    <div className="wg-section-card">

      <section className="wg-pdp-related">

        {/* HEADER */}
        <div className="wg-pdp-related-head">
          <div className="wg-pdp-related-title">
            You May Also Like{" "}
            <span className="wg-pdp-related-count">
              ({relatedProducts.length})
            </span>
          </div>
        </div>

        {/* PRODUCTS */}
        <div className="wg-pdp-related-rail-wrap">
        <button
          type="button"
          className="wg-pdp-related-nav left"
          disabled={!canScrollLeft}
          onClick={() => {
            const el = relatedRef.current;
            if (!el) return;

            el.scrollBy({
              left: -el.clientWidth, // ✅ scroll full view
              behavior: "smooth",
            });
          }}
        >
          &#8249;
        </button>
        {relatedProducts?.length > 0 && (
          <div className="wg-pdp-related-rail" ref={relatedRef}>
            {relatedProducts.map((p, idx) => {
              // Default selected color
              const selectedColor =
              p._selectedColor ||
              (p.colors?.length ? p.colors[0] : null);
             // console.log("COLORS:", p.colors);
             // console.log("VARIANTS:", p.variants);
              const heroImage = (() => {
                // 1️⃣ direct color image (best case)
                if (selectedColor?.image) return selectedColor.image;
              
                // 2️⃣ try from variants
                if (selectedColor && p.variants?.length) {
                  const matched = p.variants.find(
                    (v) =>
                      v.colorName?.toLowerCase().trim() ===
                      selectedColor.name?.toLowerCase().trim()
                  );
              
                  if (matched?.frontimage) return matched.frontimage;
                }
              
                // 3️⃣ fallback
                return p.image || "/placeholder.png";
              })();
              const hasList = p.listPrice && p.listPrice > p.price;

              const handleColorSelect = (c) => {
                const updated = relatedProducts.map((item, i) =>
                  i === idx ? { ...item, _selectedColor: c } : item
                );
                setRelatedProducts(updated);
              };

              return (
                <a
                  key={idx}
                  className="wg-pdp-related-card"
                  onClick={() =>
                    navigate(`/products/${p.id}/${encodeURIComponent(p.name)}`)
                  }
                >
                  <div
                    className="wg-pdp-related-img"
                    style={{ backgroundImage: `url(${heroImage})` }}
                  >
                   <RelatedSwatches
                      colors={p.colors || []}
                      selectedColor={selectedColor}
                      onSelect={handleColorSelect}
                    />
                  </div>

                  <div className="wg-pdp-related-brand">{p.Brand}</div>
                  <div className="wg-pdp-related-title-text">{p.name}</div>

                  <div className="wg-pdp-related-price">
                    <span className="wg-pdp-related-sale">{formatPrice(p.price)}</span>
                    {hasList && <span className="wg-pdp-related-list">₹{p.listPrice}</span>}
                  </div>
                </a>
              );
            })}
          </div>
        )}

        <button
          type="button"
          className="wg-pdp-related-nav right"
          disabled={!canScrollRight}
          onClick={() => {
            const el = relatedRef.current;
            if (!el) return;

            el.scrollBy({
              left: el.clientWidth, // ✅ scroll full view
              behavior: "smooth",
            });
          }}
        >
          &#8250;
        </button>

        </div>

      </section>

    </div>
  </div>
  <div className="wg-pdp-shell">
    <div className="wg-section-card">
      <div className="wg-pdp-info-row">

        <section className="wg-pdp-reviews">

          {/* HEADER */}
          <div className="wg-pdp-reviews-head">
            <div className="wg-pdp-reviews-title">
              Reviews{" "}
              <span className="wg-pdp-reviews-count">
                ({reviews.length})
              </span>
            </div>
          </div>

          <div className="wg-pdp-reviews-body">

            <div className="wg-reviews-top">

              {/* AVG RATING */}
              <div className="wg-reviews-card">
                <div className="wg-reviews-score">
                  <div className="wg-reviews-number">
                    {avgRating}
                  </div>

                  <div className="wg-reviews-stars">
                     {[1,2,3,4,5].map((star) => (
                      <button
                        key={star}
                        type="button"
                        onClick={() => {
                            setReviewForm({ ...reviewForm, rating: star });
                            setShowReviewModal(true);
                          }}
                      >
                        <Star filled={star <= Math.round(avgRating)} />
                      </button>
                    ))}
                  </div>

                  <div className="wg-reviews-overall">
                    Based on {reviews.length} reviews
                  </div>
                </div>
              </div>

              {/* CUSTOMER PHOTOS */}
              <div className="wg-reviews-card">
                <div
                  className="wg-reviews-title-small"
                  style={{ fontWeight: 800, color: "var(--wg-navy)" }}
                >
                  Customer Photos
                </div>

                <div className="wg-reviews-photos-wrap">
                  <button type="button" className="wg-reviews-nav left">
                    &#8249;
                  </button>

                  <div className="wg-reviews-photos">
                    {reviewPhotosData.map((photo, i) => (
                      <img
                        key={i}
                        src={photo.src}
                        alt="review"
                        style={{ width: 80, marginRight: 8 }}
                      />
                    ))}
                  </div>

                  <button type="button" className="wg-reviews-nav right">
                    &#8250;
                  </button>
                </div>
              </div>

              {/* WRITE REVIEW */}
              <div className="wg-reviews-card">
                <div
                  className="wg-reviews-title-small"
                  style={{ fontWeight: 800, color: "var(--wg-navy)" }}
                >
                  Review this product
                </div>

                <div className="wg-review-cta">
                  <p style={{ margin: 0, color: "var(--wg-text-muted)" }}>
                    Tell us how this product worked for you.
                  </p>

                 <div className="wg-review-stars-pick" id="wgReviewModalStars">
                    {[1,2,3,4,5].map((star) => (
                      <button
                        key={star}
                        type="button"
                        className="wg-review-star-btn"
                        onClick={() => {
                            setReviewForm({ ...reviewForm, rating: star });
                            setShowReviewModal(true);
                          }}
                      >
                        <Star  />
                      </button>
                    ))}
                  </div>
                </div>
              </div>

            </div>

            {/* REVIEW LIST */}
            <div className="wg-pdp-review-list">
              {reviews.map((review, i) => (
              <article key={i} className="wg-pdp-review">
                <div className="wg-pdp-review-head">
                  <div className="wg-pdp-reviewer">
                     {review.name}
                  </div>
                  <div className="wg-pdp-review-date">{formatDate(review.created_at)}</div>
                </div>
                  <div className="wg-pdp-review-stars">
                    {[1,2,3,4,5].map((star) => (
                      <Star
                        key={star}
                        filled={star <= Math.round(review.rating)}
                      />
                    ))}
                  </div>

                  <div className="wg-pdp-review-body">
                    {review.review_body}
                  </div>
                  <ReviewActions
                      onHelpful={() => handleHelpful(review.id)}
                      onNotHelpful={() => handleNotHelpful(review.id)}
                      onReport={() => console.log("report", review.id)}
                    />
                </article>
              ))}
            </div>

          </div>
        </section>

      </div>
    </div>
  </div>
  {showCustomize && (
    <div className="wg-custom-overlay">

      <div className="wg-custom-card">

        {/* CLOSE */}
        <button
          type="button"
          className="wg-custom-close"
          onClick={() => setShowCustomize(false)}
        >
          &#10005;
        </button>

        <div className="wg-custom-grid">

          {/* LEFT SIDE */}
          <div className="wg-custom-summary">

            <div className="wg-custom-summary-head">
              <div className="wg-custom-thumb">
                {mainImage && <img src={mainImage} alt="thumb" />}
              </div>

              <div className="wg-custom-meta">
                <div className="wg-custom-title">
                  {product.styleName}
                </div>

                <div className="wg-custom-item">
                  {product.styleCode}
                </div>

                <div className="wg-custom-badges">
                  <span className="wg-custom-badge">
                    {selectedColor}
                  </span>
                  <span className="wg-custom-badge">
                    {selectedSize}
                  </span>
                </div>
              </div>
            </div>

            {/* PRESET */}
            <div className="wg-custom-fees">

              <label style={{ fontWeight: 700, color: "var(--wg-navy)" }}>
                Preset Customer Designs
              </label>

              <div className="wg-custom-select-row is-single">
                <select
                  value={selectedPreset}
                  onChange={(e) => setSelectedPreset(e.target.value)}
                >
                  <option value="">Select preset</option>
                  {customerPresets.map((p) => (
                    <option key={p.id} value={p.id}>
                      {p.label}
                    </option>
                  ))}
                </select>

                <button onClick={() => setSelectedPreset("")}>
                  ×
                </button>
              </div>

              {/* SUMMARY */}
              <h4>Summary</h4>
              <ul className="wg-custom-fee-list">
                {customSelections.map((item, i) => (
                  <li key={i}>
                    {item.label} - ₹{item.fee}
                  </li>
                ))}
              </ul>

              {/* QTY */}
              <div className="wg-custom-qty">
                <label>Quantity</label>
                <input
                  type="number"
                  min="1"
                  value={customQty}
                  onChange={(e) => setCustomQty(e.target.value)}
                />
              </div>

              {/* TOTAL */}
              <div className="wg-custom-total">
                <span>Total</span>
                <span>₹{customTotal}</span>
              </div>

            </div>

            {/* ACTIONS */}
          {/*   <div className="wg-custom-actions">
              <button
                className="wg-custom-btn secondary"
               // onClick={handleAddToQuote}
              >
                Add to Quote
              </button>

              <button
                className="wg-custom-btn"
                //onClick={handleAddToCart}
              >
                Add to Cart
              </button>
            </div> */}

            <div className="wg-custom-info">
              Select preset or customize from right side.
            </div>

          </div>

          {/* RIGHT SIDE */}
          <div className="wg-custom-outline-wrap">

            {/* SIDE TOGGLE */}
            <div className="wg-custom-side-toggle">
              <span>View</span>

              <div className="wg-custom-side-pills">
                {customizationSides.map((side) => (
                  <button
                    key={side.id}
                    className={activeSide === side.id ? "active" : ""}
                    onClick={() => setActiveSide(side.id)}
                  >
                    {side.label}
                  </button>
                ))}
              </div>
            </div>

            {/* OUTLINE */}
            <div className="wg-custom-outline">
              <span className="wg-custom-outline-marker left">R</span>
              <span className="wg-custom-outline-marker right">L</span>

              <div className="wg-custom-outline-base">
                {/* clickable zones */}
                {customizationZones
                  .filter((z) => z.side === activeSide)
                  .map((zone) => (
                    <div
                      key={zone.id}
                      className="custom-zone"
                      style={{
                        position: "absolute",
                        top: zone.top,
                        left: zone.left,
                        cursor: "pointer",
                      }}
                      onClick={() => setActiveZone(zone)}
                    >
                      ●
                    </div>
                  ))}
              </div>
            </div>

            {/* DETAIL */}
            <div className="wg-custom-detail">

              <h4>
                {activeZone ? activeZone.label : "Choose a zone"}
              </h4>

              {/* CUSTOMER */}
              <label style={{ fontWeight: 700, color: "var(--wg-navy)" }}>
                Customer specific
              </label>

              <div className="wg-custom-select-row">
                <select
                  value={selectedCustomer}
                  onChange={(e) => setSelectedCustomer(e.target.value)}
                >
                  <option value="">Select</option>
                  {customerOptions.map((opt) => (
                    <option key={opt.id} value={opt.id}>
                      {opt.label}
                    </option>
                  ))}
                </select>

                <button onClick={() => setSelectedCustomer("")}>
                  ×
                </button>
              </div>

              <input
                type="text"
                className="wg-custom-text-input"
                placeholder="Enter custom text"
                value={customText}
                onChange={(e) => setCustomText(e.target.value)}
              />

              {/* STANDARD */}
              <label style={{ fontWeight: 700, color: "var(--wg-navy)" }}>
                Standard options
              </label>

              <div className="wg-custom-select-row">
                <select
                  value={selectedStandard}
                  onChange={(e) => setSelectedStandard(e.target.value)}
                >
                  <option value="">Select</option>
                  {standardOptions.map((opt) => (
                    <option key={opt.id} value={opt.id}>
                      {opt.label}
                    </option>
                  ))}
                </select>

                <button onClick={() => setSelectedStandard("")}>
                  ×
                </button>
              </div>

            </div>

            {/* CLEAR ALL */}
            <button
              className="wg-custom-clear-all"
              onClick={() => {
                setSelectedCustomer("");
                setSelectedStandard("");
                setCustomText("");
                setCustomSelections([]);
              }}
            >
              Clear all customizations
            </button>

          </div>

        </div>
      </div>
    </div>
  )}
  <div className="wg-pdp-shell">
    <div className="wg-newsletter">
      <div className="wg-newsletter-head">
        <div className="wg-newsletter-title">Stay in the loop
        {message && (
        <div style={{ marginTop: "10px", color: "green" }}>
          {message}
        </div>
      )}
        </div>
        <div className="wg-newsletter-sub">
          Get product drops, promos, and safety tips straight to your inbox.
        </div>
      </div>

      <div className="wg-newsletter-form">
        <input
          type="text"
          name="name"
          value={newsletter.name}
          onChange={handleNewsletterChange}
          className="wg-newsletter-input"
          placeholder="Name"
        />

        <input
          type="email"
          name="email"
          value={newsletter.email}
          onChange={handleNewsletterChange}
          className="wg-newsletter-input"
          placeholder="Email"
        />

        <input
          type="tel"
          name="phone"
          value={newsletter.phone}
          onChange={handleNewsletterChange}
          className="wg-newsletter-input"
          placeholder="Mobile phone"
        />
       <button
        type="button"
        className="wg-newsletter-btn"
        onClick={handleNewsletterSubmit}
        disabled={submitting}
      >
        {submitting ? "Signing up..." : "Sign up"}
      </button>
      </div>

      <label className="wg-newsletter-waiver">
        
        <input
          type="checkbox"
          name="agree"
          checked={newsletter.agree}
          aria-label="Agree to marketing messages"
          onChange={handleNewsletterChange}
        />
        <span>
          I agree to receive promotional and personalized marketing messages.
          Only one of email or phone is required. Message/data rates may apply.
          Opt out anytime.
        </span>
      </label>
    </div>
  </div>

    {/* MEDIA OVERLAY */}
    {showMediaOverlay && (
    <div className="wg-media-overlay">
      <div className="wg-media-overlay-card">

        <div className="wg-media-overlay-left">
          {currentMediaList[overlayIndex]?.type === "video" ? (
            <video
              src={currentMediaList[overlayIndex]?.src}
              controls
              autoPlay
            />
          ) : (
            <img
              src={currentMediaList[overlayIndex]?.src}
              alt="preview"
            />
          )}
        </div>

        <button
          className="wg-media-close"
          onClick={closeMediaOverlay}
        >
          ✕
        </button>

      </div>
    </div>
  )}

    {/* CART MODAL */}
    {showCartModal && (
  <div className="wg-modal-overlaycart">
    <div className="wg-modal-card">
      <div className="wg-modal-head">
        <div className="wg-modal-title">Added to Cart</div>
        <button onClick={() => setShowCartModal(false)}>✕</button>
      </div>

      <div className="wg-modal-body">
        <div className="wg-modal-line">
          <span>Product</span>
          <span>{modalData.name}</span>
        </div>
        <div className="wg-modal-line">
          <span>Color</span>
          <span>{modalData.color === "no_color" ? "No color" : modalData.color}</span>
        </div>
        <div className="wg-modal-line">
          <span>Size</span>
          <span>{modalData.size === "no_size" ? "No size" : modalData.size}</span>
        </div>
        <div className="wg-modal-line">
          <span>Quantity</span>
          <span>{modalData.qty}</span>
        </div>
      </div>

      <div className="wg-modal-actions">
        <button
          className="wg-modal-primary"
          onClick={() => navigate("/cart")}
        >
          Checkout
        </button>

        <button
          className="wg-modal-secondary"
          onClick={() => setShowCartModal(false)}
        >
          Continue Shopping
        </button>
      </div>
    </div>
  </div>
)}
    {/* QUOTE MODAL */}
    {showQuoteModal && (
  <div
    className="wg-modal-overlaycart"
    onClick={(e) => {
      if (e.target === e.currentTarget) {
        setShowQuoteModal(false);
      }
    }}
  >
    <div className="wg-modal-card">
      <div className="wg-modal-head">
        <div className="wg-modal-title">Added to Quote</div>
        <button onClick={() => setShowQuoteModal(false)}>✕</button>
      </div>

      <div className="wg-modal-body">
        <div className="wg-modal-line">
          <span>Product</span>
          <span>{modalData.name}</span>
        </div>
        <div className="wg-modal-line">
          <span>Color</span>
          <span>{modalData.color === "no_color" ? "No color" : modalData.color}</span>
        </div>
        <div className="wg-modal-line">
          <span>Size</span>
          <span>{modalData.size === "no_size" ? "No size" : modalData.size}</span>
        </div>
        <div className="wg-modal-line">
          <span>Quantity</span>
          <span>{modalData.qty}</span>
        </div>
      </div>

      <div className="wg-modal-actions">
      <button
  className="wg-modal-primary"
  onClick={async () => {
    try {
      await addToQuote({
        product_id: product.id,
        selectedColor: modalData.color,
        selectedSize: modalData.size,
        quantity: modalData.qty,
      });

      setShowQuoteModal(false);
     // alert("Quote submitted!");
    } catch (err) {
      console.log(err);
    }
  }}
>
  Add to Quote
</button>
        <button
          className="wg-modal-secondary"
          onClick={() => setShowQuoteModal(false)}
        >
          Continue Shopping
        </button>
      </div>
    </div>
  </div>
)}

    {/* REVIEW MODAL */}
    {showReviewModal && (
      <div className={`wg-modal-overlay ${showReviewModal ? "is-open" : ""}`} id="wgReviewModal">
        <div className="wg-modal-card wg-modal-card-review">
          <div className="wg-modal-head">
            <div className="wg-modal-title">Write a Review</div>
            <button type="button" className="wg-modal-close" id="wgReviewClose" onClick={() => setShowReviewModal(false)}>
              &#10005;
            </button>
          </div>

          <div className="wg-modal-body">
            <div className="wg-review-login-note">
              Please log in to submit a review.
            </div>

            <div className="wg-review-stars-pick" id="wgReviewModalStars">
              {[1,2,3,4,5].map((star) => (
                <button
                  key={star}
                  type="button"
                  onClick={() =>
                    setReviewForm({ ...reviewForm, rating: star })
                  }
                >
                  {star <= reviewForm.rating ? "⭐" : "☆"}
                </button>
              ))}
            </div>

            <div style={{ fontWeight: 700, color: "var(--wg-navy)" }} id="wgReviewProductName">{product.name}</div>

            <div className="wg-review-form">
              <div className="wg-review-inline" style={{ justifyContent: "space-between" }}>
                <span id="wgReviewModalRatingText" style={{ color: "var(--wg-text-muted)", fontWeight: 600 }}> you rated this {reviewForm.rating} stars</span>
              </div>

              <label>
                Your feedback{" "}
                <a href="#" style={{ color: "var(--wg-orange)", textDecoration: "none" }}>
                  Review guidelines
                </a>
              </label>

              <textarea
                id="wgReviewText"
                rows="4"
                value={reviewForm.text}
                onChange={(e) =>
                  setReviewForm({ ...reviewForm, text: e.target.value })
                }
              />

              <label>Review title</label>
              
              <input
                type="text"
                id="wgReviewTitle"
                value={reviewForm.title}
                onChange={(e) =>
                  setReviewForm({ ...reviewForm, title: e.target.value })
                }
              />

              <label>Name to display</label>
              <input
                type="text"
                id="wgReviewDisplayName"
                value={reviewForm.name}
                onChange={(e) =>
                  setReviewForm({ ...reviewForm, name: e.target.value })
                }
              />

              <label>Email address</label>
              <input
                  type="email"
                  id="wgReviewEmail"
                  value={reviewForm.email}
                  onChange={(e) =>
                    setReviewForm({ ...reviewForm, email: e.target.value })
                  }
                />

              <div className="wg-review-inline" style={{ alignItems: "center", gap: "8px" }}>
                <input
                      type="checkbox"
                      id="wgReviewTerms"
                      checked={reviewForm.agree}
                      onChange={(e) =>
                        setReviewForm({ ...reviewForm, agree: e.target.checked })
                      }
                    />
                <label htmlFor="wgReviewTerms">I agree to the terms and conditions</label>
              </div>

              <div className="wg-review-inline" style={{ alignItems: "center", gap: "8px" }}>
                <input
                  type="checkbox"
                  id="wgReviewEmails"
                  checked={reviewForm.receiveEmails}
                  onChange={(e) =>
                    setReviewForm({ ...reviewForm, receiveEmails: e.target.checked })
                  }
                />
                <label htmlFor="wgReviewEmails">You may receive emails related to this review</label>
              </div>

              <label>Add photos</label>
              <input
                  type="file"
                  id="wgReviewImages"
                  multiple
                  onChange={(e) => setReviewImages(e.target.files)}
                />
            </div>
          </div>

          <div className="wg-modal-actions">
            <button
                type="button"
                className="wg-modal-primary"
                id="wgReviewSubmit"
                onClick={submitReview}
              >
                Submit Review
              </button>
            <button type="button" className="wg-modal-secondary" id="wgReviewCancel" onClick={() => setShowReviewModal(false)}>Cancel</button>
          </div>
        </div>
      </div>
    )}
    {/* PHOTO OVERLAY */}
    <div className="wg-photo-overlay" id="wgPhotoOverlay">
      <div className="wg-photo-card">
        <div className="wg-photo-left">
          <div className="wg-photo-img" id="wgPhotoImg"></div>
          <button type="button" className="wg-photo-nav left" id="wgPhotoPrev">&#8249;</button>
          <button type="button" className="wg-photo-nav right" id="wgPhotoNext">&#8250;</button>
        </div>

        <div className="wg-photo-right">
          <div className="wg-photo-title" id="wgPhotoTitle"></div>
          <div className="wg-photo-meta">
            <div className="wg-photo-stars" id="wgPhotoStars"></div>
            <div id="wgPhotoDate"></div>
          </div>

          <div className="wg-photo-body" id="wgPhotoBody"></div>
          <div className="wg-photo-name" id="wgPhotoName"></div>

          <div className="wg-photo-actions">
            <div className="wg-photo-helpful">
              <button type="button" id="wgPhotoHelpfulYes">
                👍 <span id="wgPhotoHelpfulYesCount">0</span>
              </button>
              <button type="button" id="wgPhotoHelpfulNo">
                👎 <span id="wgPhotoHelpfulNoCount">0</span>
              </button>
            </div>

            <button type="button" className="wg-photo-btn" id="wgPhotoReport">
              Report
            </button>
          </div>
        </div>

        <button type="button" className="wg-photo-close" id="wgPhotoClose">
          &#10005;
        </button>
      </div>
    </div>

    </div>
  );
  };

  export default ProductDetailPage;
